/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type TypeEnum = 'BUY' | 'SELL' | '11184809';

export const TypeEnum = {
  BUY: 'BUY' as TypeEnum,
  SELL: 'SELL' as TypeEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as TypeEnum
};
